import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/welfare';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/60 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-background-50/90 text-foreground-700">
            {article.tags[0]}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 font-heading">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-400">{article.date}</span>
          <span className="flex items-center gap-1 text-xs text-primary-500 font-medium">
            阅读全文
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}